/** Melodías — public-domain motifs to guess; plus an audio-memory mode. */

export const MELODIES = [
  { id: 'oda', name: { es: 'Oda a la Alegría', en: 'Ode to Joy' }, notes: ['E4', 'E4', 'F4', 'G4', 'G4', 'F4', 'E4', 'D4', 'C4', 'C4', 'D4', 'E4'] },
  { id: 'twinkle', name: { es: 'Estrellita', en: 'Twinkle Twinkle' }, notes: ['C4', 'C4', 'G4', 'G4', 'A4', 'A4', 'G4', 'F4', 'F4', 'E4', 'E4', 'D4'] },
  { id: 'birthday', name: { es: 'Feliz Cumpleaños', en: 'Happy Birthday' }, notes: ['C4', 'C4', 'D4', 'C4', 'F4', 'E4', 'C4', 'C4', 'D4', 'C4', 'G4', 'F4'] },
  { id: 'elise', name: { es: 'Para Elisa', en: 'Für Elise' }, notes: ['E4', 'D#4', 'E4', 'D#4', 'E4', 'B4', 'D4', 'C4', 'A4'] },
  { id: 'bells', name: { es: 'Cascabeles', en: 'Jingle Bells' }, notes: ['E4', 'E4', 'E4', 'G4', 'C4', 'D4', 'E4'] },
  { id: 'lamb', name: { es: 'Mary tenía un corderito', en: 'Mary Had a Little Lamb' }, notes: ['E4', 'D4', 'C4', 'D4', 'E4', 'E4', 'E4', 'D4', 'D4'] },
]

/** Tone pads for the memory mode. */
export const TONES = [
  { label: 'Do', note: 'C4' },
  { label: 'Re', note: 'D4' },
  { label: 'Mi', note: 'E4' },
  { label: 'Sol', note: 'G4' },
  { label: 'La', note: 'A4' },
]
